<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="visible"
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
      :header="form.id ? 'Editar Entidade' : 'Adicionar Entidade'"
      modal
    >
      <form @submit.prevent="submit" ref="form">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label>Nome</label>
            <InputText
              v-model="form.name"
              name="name"
              v-validate="'required'"
              :class="{ 'p-invalid': errors.has('name') }"
            />
            <span v-if="errors.has('name')" class="p-error"
              >Nome é Obrigatório</span
            >
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Morada</label>
            <InputText
              v-model="form.address"
              name="address"
              v-validate="'required'"
              :class="{ 'p-invalid': errors.has('address') }"
            />
            <span v-if="errors.has('address')" class="p-error">
              Morada é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Código Postal</label>
            <InputText
              v-model="form.zip_code"
              name="zip_code"
              v-validate="'required'"
              :class="{ 'p-invalid': errors.has('zip_code') }"
              autocomplete="off"
            />
            <span v-if="errors.has('zip_code')" class="p-error">
              Código Postal é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Localidade</label>
            <InputText
              v-model="form.city"
              name="city"
              v-validate="'required'"
              :class="{ 'p-invalid': errors.has('city') }"
              autocomplete="off"
            />
            <span v-if="errors.has('city')" class="p-error">
              Localidade é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Telefone</label>
            <InputText
              v-model="form.telephone"
              name="telephone"
              v-validate="'required'"
              :class="{ 'p-invalid': errors.has('telephone') }"
              autocomplete="off"
            />
            <span v-if="errors.has('telephone')" class="p-error">
              Telefone é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Telemóvel</label>
            <InputText
              v-model="form.tlmvl"
              name="tlmvl"
              :class="{ 'p-invalid': errors.has('tlmvl') }"
              autocomplete="off"
            />
            <span v-if="errors.has('tlmvl')" class="p-error">
              Telemóvel é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Email</label>
            <InputText
              v-model="form.email"
              name="email"
              :class="{ 'p-invalid': errors.has('email') }"
              autocomplete="off"
            />
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Contribuinte</label>
            <InputText
              v-model="form.nif"
              name="nif"
              :class="{ 'p-invalid': errors.has('nif') }"
              autocomplete="off"
            />
          </div>
        </div>
      </form>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import EntityService from "@/services/entities.service";
export default {
  name: "EntityForm",
  components: {},
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: {},
    };
  },
  watch: {
    async visible() {
      this.reset();
      if (this.visible === true) {
        this.$validator.resume();
        this.form = { ...this.data };
      }
    },
  },
  async created() {},
  methods: {
    reset() {
      this.form = {
        id: null,
      };
      this.$validator.pause();
      this.$validator.reset();
    },
    cancel() {
      this.$validator.pause();
      this.$validator.reset();
      this.reset();
      return this.$emit("cancel");
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }
      this.$validator.pause();
      this.$validator.reset();
      if (this.form.id) {
        return await EntityService.update(this.form.id, this.form).then(
          (response) => {
            if (!response) {
              return this.$toast.add({
                severity: "error",
                summary: `Erro ao Atualizar Entidade`,
                detail: "",
                life: 3000,
              });
            }
            this.$toast.add({
              severity: "success",
              summary: `Entidade Atualizada`,
              detail: "",
              life: 3000,
            });
            return this.$emit("updated", response);
          }
        );
      } else {
        return EntityService.create(this.form).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Criar Entidade`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Entidade Criada`,
            detail: "",
            life: 3000,
          });
          return this.$emit("created", response);
        });
      }
    },
  },
};
</script>
